export default __webpack_public_path__ + "static/media/m3.213b6352.jpg";